import {DefaultApi} from "./generated";

export * from './generated/models';
export * from './generated/runtime';

export class ModelApi extends DefaultApi {}
